import { MouseEvent, ReactElement, useCallback, useMemo } from 'react'

import { Spacing } from '../../../../../../enums/spacing'
import { Flex } from '../../../../../Flex'
import { IconButton, IconButtonProps } from '../../../../../IconButton'
import { NavListItemChildren } from '../../../../elements/NavListItem'
import { NavListItemText } from '../../../../elements/NavListItemText'
import * as Styled from './styles'

type IconButtonsProps<T> = Partial<NavListItemChildren<T>> & {
  iconButtons: IconButtonProps[]
}

export const IconButtons = <T,>({ iconButtons, item, textColor }: IconButtonsProps<T>): ReactElement => {
  const handleIconButtonClick = useCallback(
    (onItemClick: IconButtonProps['onItemClick']) => (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()
      event.stopPropagation()

      onItemClick?.(item?.id)
    },
    [item?.id],
  )

  const renderIconButtons = useMemo(
    () =>
      iconButtons.map(({ onItemClick, size, ...props }, index) => (
        <IconButton {...props} key={index} onClick={handleIconButtonClick(onItemClick)} size={size ?? 'sm'} />
      )),
    [iconButtons, handleIconButtonClick],
  )

  return (
    <Flex alignItems="center" justifyContent="space-between" width="100%">
      <NavListItemText color={textColor} variant={item?.variant}>
        {item?.children}
      </NavListItemText>

      <Styled.IconButtonHoverActions>
        <Flex gap={Spacing.S4}>{renderIconButtons}</Flex>
      </Styled.IconButtonHoverActions>
    </Flex>
  )
}
